import MeaPage from "../../../components/MeaPage";
import { useEffect, useRef, useState } from "react";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import schoolsAPI from "../../../services/schools";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import uiDataAPI from "../../../services/ui_data";
import { Checkbox } from "primereact/checkbox";
import MeaLoadingContent from "../../../components/MeaLoadingContent";
import { PERMISSION_SCHOOL_POLICIES } from "../../../permissions";
import { BlockUI } from "primereact/blockui";
import { Message } from "primereact/message";
import { useAuthContext } from "../../../hooks/useAuthContext";
import MeaLink from "../../../components/MeaLink";
import { BreadCrumb } from "primereact/breadcrumb";

const PermissionsPage = () => {
    const { currentMembership, hasPermission } = useAuthContext();
    const schoolId = currentMembership?.school_id;
    const accessToken = "";

    const [policies, setPolicies] = useState(null);
    const [etag, setEtag] = useState(null);
    const [refresh, setRefresh] = useState(null);
    const [loading, setLoading] = useState(true);
    //
    const uiDataPermissionListQuery = uiDataAPI.UiDataPermissionList(accessToken);
    const permissions = uiDataPermissionListQuery?.data?.data;
    //
    useEffect(() => {
        const fetchSchoolData = async () => {
            schoolsAPI.GetOneSchool(schoolId, accessToken).then((data) => {
                const _policies = JSON.parse(data?.data?.policies);
                setPolicies(_policies);
                setEtag(data?.data?.policies_etag);
            }).catch((error) => {
                console.error("Failed to fetch school data", error);
            }).finally(() => {
                setLoading(false);
            }
            );
        }
        if (schoolId) {
            fetchSchoolData();
        }
    }, [schoolId, accessToken, refresh]);
    //
    const toast = useRef();
    //
    const handlePermissionChange = (role, permissionId, checked) => {
       
        setLoading(true);
        schoolsAPI.UpdateSchoolPolicies(schoolId, accessToken, {
            action: checked ? "ADD" : "REMOVE",
            role: role,
            permission: permissionId,
            etag: etag
        }).then((data) => {
            toast.current.show({
                severity: "success",
                summary: "Succès",
                detail: "Mise à jour réussie!",
                life: 3000,
            });
            window.location.reload();
        }).catch((error) => {
            
            toast.current.show({
                severity: "error",
                summary: "Erreur",
                detail: "Erreur lors de la mise à jour!",
            });
            window.location.reload();
        }).finally(() => {
            setLoading(false);
        }
        );
    }
    //
    const breadcrum = [
        {
            label: 'Components',
            template: () => <MeaLink to={`/school/${schoolId}/admin`} icon="pi pi-home" isRipple={true}>{currentMembership?.school?.name}</MeaLink>
        },
        { label: 'Permissions' }
    ];
    //
    const hasPermissionsData = Array.isArray(permissions) && permissions.length > 0;
    const hasPoliciesData = policies && Object.keys(policies).length > 0;
    const shouldRenderTable = hasPermissionsData && hasPoliciesData;
    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <MeaPage
                title="Les roles & permissions"
                breadcrumb={<BreadCrumb model={breadcrum} />}
                showBackButton={false}
                actions={[
                    {
                        label: "Réinitialiser",
                        icon: "pi pi-file-reset",
                        disable: !hasPermission(PERMISSION_SCHOOL_POLICIES.RESET),
                        command: () => {

                            confirmDialog({
                                message: "Voulez-vous vraiment réinitialiser les permissions?",
                                header: "Confirmation",
                                icon: "pi pi-info-circle",
                                defaultFocus: "reject",
                                acceptClassName: "p-button-danger",
                                accept: () => {
                                    setLoading(true);
                                    schoolsAPI
                                        .UpdateSchoolPolicies(schoolId, accessToken, {
                                            action: "RESET"
                                        })
                                        .then((data) => {
                                            toast.current.show({
                                                severity: "success",
                                                summary: "Succès",
                                                detail: " Supprimé!",
                                                life: 3000,
                                            });
                                            window.location.reload();
                                        })
                                        .catch((error) => {
                                            toast.current.show({
                                                severity: "error",
                                                summary: "Erreur",
                                                detail: "Erreur!",
                                            });
                                        }).finally(() => {
                                            setLoading(false);
                                        });
                                },
                            });
                        },
                    }
                ]}
            >
                <MeaLoadingContent objectQuery={uiDataPermissionListQuery} >
                    <BlockUI blocked={loading} template={<i className="pi pi-spin pi-spinner" style={{ fontSize: '3rem' }}></i>}>
                        {shouldRenderTable ? (
                            <DataTable value={permissions} rowGroupMode="subheader" groupRowsBy="group" selectionMode="single" scrollable rowGroupHeaderTemplate={(data) => {
                                return (
                                    <div className="flex align-items-center gap-2">
                                        <span className="font-bold">{data.group}</span>
                                    </div>
                                );
                            }} size="small">
                                <Column field="name" header="Permissions" />
                                <Column field="admin" header="Administration" body={(item) => {
                                    return (
                                        <Checkbox
                                            checked={policies?.admin?.includes(item?.id)}
                                            readOnly
                                        />
                                    );
                                }} />
                                <Column field="staff" header="Personnel" body={(item) => {
                                    return <Checkbox checked={policies?.staff?.includes(item?.id)}
                                        onChange={(e) => {
                                            handlePermissionChange("staff", item?.id, e.checked);
                                        }}
                                    ></Checkbox>
                                }} />
                                <Column field="teacher" header="Enseignants" body={(item) => {
                                    return <Checkbox readOnly checked={policies?.teacher?.includes(item?.id)}
                                        onChange={(e) => {
                                            handlePermissionChange("teacher", item?.id, e.checked);
                                        }}
                                    ></Checkbox>
                                }} />
                                <Column field="parent" header="Parents d'élèves" body={(item) => {
                                    return <Checkbox readOnly checked={policies?.parent?.includes(item?.id)}
                                        onChange={(e) => {
                                            handlePermissionChange("parent", item?.id, e.checked);
                                        }}
                                    ></Checkbox>
                                }} />
                                <Column field="student" header="Elèves" body={(item) => {
                                    return <Checkbox readOnly checked={policies?.student?.includes(item?.id)}
                                        onChange={(e) => {
                                            handlePermissionChange("student", item?.id, e.checked);
                                        }}
                                    ></Checkbox>
                                }} />
                            </DataTable>
                        ) : (
                            <div className="flex justify-content-center">
                                
                            </div>
                        )}
                    </BlockUI>
                </MeaLoadingContent>
            </MeaPage>
        </>
    );
};
export default PermissionsPage;
